export function normalizeCNPJ(value = '') {
  return String(value)
    .replace(/[^A-Za-z0-9]/g, '')
    .toUpperCase();
}

export function isValidCNPJ(value) {
  if (!value) return false;

  const cnpj = normalizeCNPJ(value);

  if (cnpj.length !== 14) return false;
  if (!/^[A-Z0-9]{12}\d{2}$/.test(cnpj)) return false;
  if (/^(\d)\1{13}$/.test(cnpj)) return false;

  const charToValue = char => char.charCodeAt(0) - 48;

  const calculateDigit = (base, weights) => {
    const sum = base
      .split('')
      .reduce((acc, char, index) => acc + charToValue(char) * weights[index], 0);

    const rest = sum % 11;

    return rest < 2 ? 0 : 11 - rest;
  };

  const base = cnpj.slice(0, 12);
  const firstDigitWeights = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
  const secondDigitWeights = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];

  const firstDigit = calculateDigit(base, firstDigitWeights);
  const secondDigit = calculateDigit(`${base}${firstDigit}`, secondDigitWeights);

  return cnpj === `${base}${firstDigit}${secondDigit}`;
}
